var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 84,
  height: 84,
  viewBox: "0 0 84 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.1143 62.725L19 47.775L25.5714 41.6L34.1143 50.05L58.4286 26L65 32.5L34.1143 62.725Z",
  fill: "#100226"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 42,
  r: 40.5,
  stroke: "#100226",
  strokeWidth: 3
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.6272166c2ea6ba88a6ceb5fa8f4b5019.svg";